import { getResourceStore } from '../resource-store/index.tsx';

export const addResourcesListener = (fn: (...args: any) => any) =>
	getResourceStore().storeState.subscribe(fn);
